import React, { useEffect } from 'react';

import { HomePlanLink } from './HomePlanLink/HomePlanLink';
import BookSmartMeterLink from './BookSmartMeterLink/BookSmartMeterLink';
import OvoGreenlightLink from './OvoGreenlightLink/OvoGreenlightLink';
import { HomeRecoverLink } from './HomeRecoverLink/HomeRecoverLink';
import { PlanLinksWrapper as PlanLinks } from './PlanLinks';
import {
  HOME_SERVICES_BLOCK_EXISTING_CUSTOMERS,
  HOMEPLAN_NAV_LINK,
  HOMERECOVER_NAV_LINK,
} from '@/src/constants/feature-flags';
import { sandwichIds } from '@/src/constants/sandwich-ids';
import { useCustomerClassification } from '@/src/hooks/HomeServices/useCustomerClassification';
import { useDecision } from '@/src/utils/optimizely';
import { PaymOnly } from '@/src/components/BillingTypeGuards/BillingTypeGuards';

interface CustomNavProps {
  path: string;
  closeMobileMenu?: () => void;
  accountId?: string;
}
export const CustomNav = ({
  path,
  closeMobileMenu,
  accountId,
}: CustomNavProps) => {
  const [showHomePlanLink, setShowHomePlanLink] = React.useState(true);
  const [showHomeRecoverLink, setShowHomeRecoverLink] = React.useState(true);

  const [blockExistingCustomersDecision] = useDecision(
    HOME_SERVICES_BLOCK_EXISTING_CUSTOMERS,
  );
  const [flag] = useDecision(HOMEPLAN_NAV_LINK);
  const [flagHr] = useDecision(HOMERECOVER_NAV_LINK);

  const { customerActiveOrRecent } = useCustomerClassification();

  useEffect(() => {
    if (blockExistingCustomersDecision.enabled) {
      setShowHomePlanLink(!customerActiveOrRecent && flag.enabled);
      setShowHomeRecoverLink(!customerActiveOrRecent && flagHr.enabled);
    } else {
      setShowHomePlanLink(flag.enabled);
      setShowHomeRecoverLink(flagHr.enabled);
    }
  }, [
    blockExistingCustomersDecision,
    setShowHomePlanLink,
    customerActiveOrRecent,
    flag,
    flagHr,
  ]);

  return (
    <>
      <PlanLinks
        closeMobileMenu={closeMobileMenu}
        path={path}
        type="accordion"
      />
      {accountId && (
        <OvoGreenlightLink accountId={accountId} type="accordion" path={path} />
      )}
      <PaymOnly>{showHomePlanLink && <HomePlanLink />}</PaymOnly>
      {showHomeRecoverLink && <HomeRecoverLink />}
    </>
  );
};

const modify = {
  [sandwichIds.sideNavigation.plan]: ({
    path,
    closeMobileMenu,
    accountId,
  }: CustomNavProps) => (
    <CustomNav
      path={path}
      closeMobileMenu={closeMobileMenu}
      accountId={accountId}
    />
  ),
  [sandwichIds.mobileNavigation.plan]: ({
    path,
    closeMobileMenu,
    accountId,
  }: CustomNavProps) => (
    <CustomNav
      path={path}
      closeMobileMenu={closeMobileMenu}
      accountId={accountId}
    />
  ),
  [sandwichIds.sideNavigation.meterReadings]: ({
    children,
    closeMobileMenu,
  }: any) => (
    <>
      {children}
      <>
        <BookSmartMeterLink closeMobileMenu={closeMobileMenu} />
      </>
    </>
  ),
  [sandwichIds.mobileNavigation.meterReadings]: ({
    children,
    closeMobileMenu,
  }: any) => (
    <>
      {children}
      <>
        <BookSmartMeterLink closeMobileMenu={closeMobileMenu} />
      </>
    </>
  ),
};

export { modify };
